import { AbstractModel } from '@/models/base'
import type { IAbstractAttachment, IAbstractAttachmentData } from './attachment.types'

export abstract class AbstractAttachment extends AbstractModel implements IAbstractAttachment {
  readonly id?: number
  readonly file: string | File

  protected constructor(data: IAbstractAttachmentData) {
    super()

    // Validate data
    const requiredFields: (keyof IAbstractAttachmentData)[] = ['file']
    this.validate(data, requiredFields)

    if (data.id) {
      this.id = data.id
    }

    this.file = data.file!
  }
}
